import { takeEvery } from 'redux-saga/effects';
import { Action, Success } from 'typescript-fsa';

import { actions } from 'src/actions';
import { Actions } from 'src/types';

function onSignInUpWithStarted(
  _action: Action<
    Success<
      Actions.api.access.signInWithEmail.started,
      Actions.api.access.signInWithEmail.done
    >
  >
) {
  // Nothing to do here. The sign-in response used to be read out of the action
  // only to be logged whole; it is typed `any` on the ajax saga, so whatever
  // the API returned was printed to the console — admin PII at minimum, and
  // whatever the response grows to carry later (CASA finding 23). The reducer
  // is what stores the result; this handler exists for the redirect below.

  // window.location = '/' as never;
}

export function* accessSaga(): Generator {
  yield takeEvery(
    actions.api.access.signInWithEmail.done.type,
    onSignInUpWithStarted
  );
}
